import { useContext } from 'react';
import { Link } from 'react-router-dom';
import MyContext from '@/shared/contexts/AppContext';
import Links from '@/shared/constants/navegacao';
import { ModuloSistema } from '@/shared/constants/modulos-sistema.enum';

export default function RelatoriosEscolhaModuloButton(props: { className?: string }) {
  const context = useContext(MyContext);
  if (!context) return null;

  const { state } = context;

  const navbarVisivel =
    state.navbar &&
    !(state.modulo === ModuloSistema.RelatoriosAtividades && !state.username?.trim());

  if (navbarVisivel) return null;

  return (
    <Link to={Links.Escolha_Modulo} className={`btn btn-outline-secondary btn-sm ${props.className || ''}`.trim()}>
      Escolha de módulo
    </Link>
  );
}

